import { render, staticRenderFns } from "./SettingsVerifyPhoneNumber.vue?vue&type=template&id=8058512e&scoped=true&"
import script from "./SettingsVerifyPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./SettingsVerifyPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVerifyPhoneNumber.vue?vue&type=style&index=0&id=8058512e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8058512e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8058512e')) {
      api.createRecord('8058512e', component.options)
    } else {
      api.reload('8058512e', component.options)
    }
    module.hot.accept("./SettingsVerifyPhoneNumber.vue?vue&type=template&id=8058512e&scoped=true&", function () {
      api.rerender('8058512e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/SettingsVerifyPhoneNumber.vue"
export default component.exports